import React from 'react'

import { FontFragment } from 'src/graphql'

type SignatureListProps = {
  className: string
  onClick: (signatureId: string) => void
  signatures: FontFragment[]
}

const SignatureList: React.FC<SignatureListProps> = props => {
  const { className, onClick, signatures } = props
  return (
    <div className={className}>
      <ul>
        {signatures.length > 0 ? (
          signatures.map((signature, index) => (
            <li
              key={index}
              style={
                {
                  fontFamily: signature.fontName,
                  cursor: 'pointer',
                } as React.CSSProperties
              }
              onClick={() => {
                onClick(signature.id)
              }}
            >
              {signature.displayName}
            </li>
          ))
        ) : (
          <li>You don't have any signatures.</li>
        )}
      </ul>
    </div>
  )
}

export default SignatureList
